import * as React from 'react';
import isEqual from 'react-fast-compare';
import { isWhiteLabel } from '../../redux/modules/whiteLabel';
import LACrown from './LACrown/LACrown';
import { useSelector } from 'react-redux';
import WhiteLabelCrown from './WhiteLabelCrown/WhiteLabelCrown';

const Crown = () => {
    const whiteLabel = useSelector(isWhiteLabel, isEqual);
    return whiteLabel ? <WhiteLabelCrown /> : <LACrown />;
};

export default React.memo(Crown);
